"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVERTISING = 'real';
exports.DEFAUTL = 'default';
exports.PARTNER = 'partner';
exports.UNLIMITED = 'unlimited';
exports.DEMO = 'demo';
var ADS_TYPE;
(function (ADS_TYPE) {
    ADS_TYPE["BASIC"] = "basic";
    ADS_TYPE["ADVANCE"] = "advance";
})(ADS_TYPE = exports.ADS_TYPE || (exports.ADS_TYPE = {}));
exports.CampaignTypes = [exports.ADVERTISING, exports.DEFAUTL, exports.PARTNER, exports.UNLIMITED];
//# sourceMappingURL=CampaignType.js.map